export default {
	"1abdc219e7ce42941821c7bcc84f6d23": "您登陸的賬號未分段購買或訂閲過該商品，無法轉年",
	"d71485dcb16d0de54249d0606d0a5ed0": "請選擇可用代金券",
	"82147f222955596655160ee6ef03d574": "分段解鎖轉年",
	"7018ac152f55fc2bc0687d4faccc575c": "已付金額",
	"abc4d5c7f1c76f5d838c83d938aa73b2": "代金券",
	"3ea640feb27ff2c83e8b2eb9e94da9a4": "轉年成功後，您可在原訂單中查看您的轉年信息；若您購買的為自動續費類商品，轉年後自動續費將會被系統自動取消，不會再重複扣費；轉年成功後，不支持退款。",
	"d868329abbb1b37dd54042e75df8cf6a": "轉年優惠抵扣:"
}
